<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Eliminar Documento
            </h3>
            <button
                class="delete"
                aria-label="Cerrar Modal"
                @click="$emit('close')"
            />
        </header>
        <section class="modal-card-body">
            <div class="px-6">
                <div class="columns is-mobile is-multiline is-vcentered">
                    <div class="column is-12-mobile">
                        <p class="is-size-5 has-text-centered has-text-weight-light">
                            ¿Estás seguro de que deseas borrar este documento?
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <footer
            class="modal-card-foot bt-none has-background-white is-justify-content-flex-end"
        >
            <button
                class="button"
                @click="$emit('close')"
                aria-label="Cerrar Modal"
                role="button"
            >
                Volver
            </button>
            <button
                class="button is-primary"
                aria-label="Eliminar Documento"
                :disabled="loading"
                role="button"
                @click="callDeleteTaxDocument(modalData)"
            >
                Sí, borrar documento
            </button>
        </footer>
    </div>
</template> 

<script>
import { mapActions, mapState } from "vuex";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { consoleHandlerError, notificate } from "@/utils/message";
import { getSuccessMessage } from "@/utils/taxDocumentMessage";

export default {
    name: "ObligationDelete",
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        ...mapActions("taxDocument", [
            "getTotalPay",
            "getTotalCollect",
            "getAllTaxDocuments",
            "deleteTaxDocument",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        callDeleteTaxDocument(data) {
            this.loading = true;
            this.deleteTaxDocument(data.id)
                .then(() => {
                    new SegmentAnalytics().trackUpdateDocument(
                        data,
                        "documentDeleted"
                    );
                    let message = getSuccessMessage(data);
                    notificate(
                        `<strong>DOCUMENTO ELIMINADO</strong><br>El documento
                         ${message} ha sido eliminado exitosamente`,
                        "is-success is-light"
                    );
                    this.getTotalPay();
                    this.getTotalCollect();
                    this.getAllTaxDocuments().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error });
                    });
                    this.$emit("close");
                })
                .catch((error) => {
                    consoleHandlerError({ error, empty: true });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        ...mapState("taxDocument", ["modalData"]),
    },
};
</script>